import {
  brandCarlaRuiz,
  brandPepaloves,
  brandRagussa,
  brandSurkana,
  brandTeckelParis,
  brandTiffosi,
} from '@/assets/images';

const brands = [
  {
    name: 'Teckel Paris',
    image: brandTeckelParis,
    logoClass: 'max-h-[58px] md:max-h-[82px]',
  },
  {
    name: 'Ragussa',
    image: brandRagussa,
    logoClass: 'max-h-[46px] md:max-h-[64px]',
  },
  {
    name: 'Pepaloves',
    image: brandPepaloves,
    logoClass: 'max-h-[58px] md:max-h-[82px]',
  },
  {
    name: 'Carla Ruiz',
    image: brandCarlaRuiz,
    logoClass: 'max-h-[46px] md:max-h-[64px]',
  },
  {
    name: 'Tiffosi',
    image: brandTiffosi,
    logoClass: 'max-h-[46px] md:max-h-[64px]',
  },
  {
    name: 'Surkana',
    image: brandSurkana,
    logoClass: 'max-h-[58px] md:max-h-[82px]',
  },
];

export default function Brands() {
  return (
    <section id="firmas" className="relative bg-cream-100 py-14 md:py-20 border-b border-ink-900/10">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center mb-10 md:mb-12">
          <p className="text-[10px] md:text-[11px] tracking-widest-xl text-ink-500 mb-4">
            NUESTRAS FIRMAS
          </p>
          <h2 className="font-display text-2xl md:text-4xl text-ink-900">
            Marcas que forman parte de nuestra historia
          </h2>
          <div className="mt-6 h-px w-16 bg-ink-900/20"></div>
          <p className="mt-6 max-w-[560px] text-xs md:text-sm text-ink-500 leading-relaxed">
            Estas son solo algunas de las firmas que tenemos. En nuestra tienda de Llíria
            encontrarás muchas más marcas seleccionadas temporada tras temporada.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {brands.map((brand) => (
            <div
              key={brand.name}
              className="group flex items-center justify-center h-[104px] md:h-[138px] px-4 md:px-5 bg-cream-50 border border-ink-900/10 rounded-lg transition-colors duration-500 hover:border-ink-900/30"
            >
              <img
                src={brand.image}
                alt={`Logo de ${brand.name} · SANO Moda, Llíria, Valencia`}
                title={`${brand.name} · SANO Moda, Llíria, Valencia`}
                className={`w-auto max-w-full object-contain mix-blend-multiply grayscale opacity-80 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100 ${brand.logoClass}`}
              />
            </div>
          ))}
        </div>

        <div className="mt-9 md:mt-10 flex flex-col items-center gap-2">
          <p className="text-center text-xs md:text-sm text-ink-500 leading-relaxed">
            Prendas seleccionadas una a una en nuestra tienda de Llíria, Valencia.
          </p>
          <p className="text-[11px] md:text-xs tracking-[0.18em] uppercase text-ink-400">
            + muchas más firmas en tienda
          </p>
        </div>
      </div>
    </section>
  );
}